module.exports = __webpack_public_path__ + "static/img/wxqrcode.7a7e6285.jpg";